export interface IntervalButtonsProps{
    onClick:Function
}
export function IntervalButtons(props:IntervalButtonsProps){
        let firstRowButtons:JSX.Element[] = []
        let intervals:number[] = [1,2,3,4,5,6,7,8,9,10,11]
        let labels:string[] = ['b2nd', '2nd','b3rd', '3rd', '4th', 'b5th','5th', 'b6th', '6th', 'b7th', '7th']
        intervals.forEach((interval:number, index:number) => {
            const label:string = labels[index]
          let b:JSX.Element = <IntervalButton interval={interval} label={label} onClick={props.onClick} key={index}/>
          firstRowButtons.push(b)
        })
        return  <div>
                  <div className='first-row'>{firstRowButtons}</div>
                </div>
}
export interface IntervalButtonProps{
  interval:number
  label:string
  onClick:Function
}
export function IntervalButton(props:IntervalButtonProps){
  const onClick = (e:React.MouseEvent) => {
    e.stopPropagation()
    props.onClick(props.interval)
}
  return  <button className="note-button" onClick={onClick} type="button">
            {props.label}
          </button>
}